<template>
  <div class="w-100 h-100 d-flex flex-column statistics">
    <div
      class="label-text text-secondary"
      style="margin-bottom:8px;"
    >
      <span>Statistics</span>
    </div>
    <div
      class="p-1 rounded border-default border flex-fill overflow-auto d-flex flex-column position-relative"
    >
      <div
        v-if="loading"
        class="position-absolute text-center d-flex flex-column justify-content-center align-items-center"
        style="top:0;right:0;left:0;bottom:0;"
      >
        <b-spinner />
      </div>
      <div
        class="position-absolute"
        style="top:5px; right:5px;"
      >
        <b-button
          variant="bg-white"
          :disabled="loading"
          @click="$emit('refresh')"
        >
          <GjIcon name="Refresh" />
        </b-button>
      </div>
      <template v-if="stats">
        <div class="d-flex align-items-center info-row">
          <span class="text-secondary label-field">
            Frame size:
          </span>
          <span>{{ `${stats.width || '-'}x${stats.height || '-'} ` }} </span>
        </div>
        <div class="d-flex align-items-center info-row">
          <span class="text-secondary label-field">
            Frame rate:
          </span>
          <span>
            {{ stats.frameRate || '-' }}
          </span>
        </div>
        <!-- VIDEOS -->
        <div class="d-flex align-items-center info-row">
          <span class="text-secondary label-field">
            Video Codec:
          </span>
          <span>
            {{ stats.videoCodec || '-' }}
          </span>
        </div>
        <!-- <div class="d-flex align-items-center info-row">
          <span class="text-secondary label-field">
            Video Profile:
          </span>
          <span>
            {{ stats.videoProfile || '-' }}
          </span>
        </div> -->
        <!--AUDIO -->
        <div class="d-flex align-items-center info-row">
          <span class="text-secondary label-field">
            Audio Codec:
          </span>
          <span>
            {{ stats.audioCodec || '-' }}
          </span>
        </div>
        <!-- <div class="d-flex align-items-center info-row">
          <span class="text-secondary label-field">
            Audio Profile:
          </span>
          <span>
            {{ stats.audioProfile || '-' }}
          </span>
        </div> -->
        <!-- <div class="d-flex align-items-center info-row">
          <span class="text-secondary label-field">
            Audio Sample Rate:
          </span>
          <span>
            {{ stats.sampleRate || '-' }}
          </span>
        </div> -->
        <!-- <div class="d-flex align-items-center info-row">
          <span class="text-secondary label-field">
            Audio Sample Size:
          </span>
          <span>
            {{ stats.audioSampleSize }}
          </span>
        </div> -->
        <!-- endAudio -->
        <div class="d-flex align-items-center info-row">
          <span class="text-secondary label-field">
            Duration:
          </span>
          <span>
            {{ stats.duration || '-' }}
          </span>
        </div>
        <div class="d-flex align-items-center info-row">
          <span class="text-secondary label-field">
            Stream Bandwidth:
          </span>
          <span>
            {{ stats.streamBandwidth || '-' }}
          </span>
        </div>
        <!-- <div class="d-flex align-items-center info-row">
          <span class="text-secondary label-field">
            Channles:
          </span>
          <span>
            {{ stats.channels || '-' }}
          </span>
        </div> -->
        <!-- <div class="d-flex align-items-center info-row">
          <span class="text-secondary label-field">
            Input Active:
          </span>
          <span>
            {{ active ? 'Yes' : 'No' }}
          </span>
        </div> -->
        <!-- <div class="d-flex align-items-center info-row">
          <span class="text-secondary label-field">
            Compat:
          </span>
          <span>
            {{ stats.compat || '-' }}
          </span>
        </div> -->
        <!-- <div class="d-flex align-items-center info-row">
          <span class="text-secondary label-field">
            Level:
          </span>
          <span>
            {{ stats.level || '-' }}
          </span>
        </div> -->
        <!-- <div class="d-flex align-items-center info-row">
          <span class="text-secondary label-field">
            Encoder:
          </span>
          <span>
            {{ stats.encoder }}
          </span>
        </div> -->
      </template>
      <div
        v-else
        class="text-secondary text-sm"
      >
        <p>Nothing to show</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JobStatistics',
  props: {
    stats: {
      type: Object,
      default: null,
    },
    active: {
      type: Boolean,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.info-row {
  margin-bottom: 7px;
  .label-field {
    margin-right: 7px;
  }
}
.statistics {
  flex-basis: 0px;
  flex-grow: 1;
  overflow-y: auto;
}
</style>
